import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSource} from "../../utils/form/application_form_source";
import {getAmplitudeLeadFormInquiryTopics} from "./get_amplitude_lead_form_inquiry_topics";
import {getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit, ILeadSubmitInquirySelection} from "./get_amplitude_lead_form_inquiry_topics_selected";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

type LeadResponseProperties =
    | {
          leadResponse: IApplicationData;
          marketingApproval?: never;
      }
    | {
          /** Each product carries its own transaction_id for events covering several created leads at once. */
          leadResponse?: never;
          marketingApproval: boolean;
      };

// DS-A-44
export type IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams = IGetAmplitudeLeadFormStartEventPropertiesParams &
    LeadResponseProperties & {
        inquirySelection: ILeadSubmitInquirySelection;
        ctaText?: string;
        isPriceNegotiation?: boolean;
    };

export const getAmplitudeLeadFormGenerateLeadEventProperties = (params: IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams) => {
    const {leadResponse, marketingApproval, inquirySelection, trackingContext, leadData, source, sourceSection, eventAction, ctaText, isPriceNegotiation} =
        params;

    const base = getAmplitudeLeadFormStartEventProperties({
        trackingContext,
        leadData,
        source,
        sourceSection,
        eventAction
    });

    const inquiryTopics = source === ApplicationSource.NegotiatePrice || isPriceNegotiation ? [] : getAmplitudeLeadFormInquiryTopics(source);
    const inquiryTopicsSelected = getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit(source, inquirySelection);

    const resolvedMarketingApproval = marketingApproval ?? Boolean(leadResponse?.marketing_email || leadResponse?.marketing_sms);

    return {
        ...base,
        ...(ctaText ? {cta_text: ctaText} : {}),
        ...(leadResponse ? {transaction_id: leadResponse.uuid} : {}),
        inquiry_topics: inquiryTopics,
        inquiry_topics_selected: inquiryTopicsSelected,
        marketing_approval: resolvedMarketingApproval
    };
};
import {IApplicationData} from "../../types/IApplicationData";
import {ApplicationSource} from "../../utils/form/application_form_source";
import {getAmplitudeLeadFormInquiryTopics} from "./get_amplitude_lead_form_inquiry_topics";
import {getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit, ILeadSubmitInquirySelection} from "./get_amplitude_lead_form_inquiry_topics_selected";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

type LeadResponseProperties =
    | {
          leadResponse: IApplicationData;
          marketingApproval?: never;
      }
    | {
          /** Each product carries its own transaction_id for events covering several created leads at once. */
          leadResponse?: never;
          marketingApproval: boolean;
      };

// DS-A-44
export type IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams = IGetAmplitudeLeadFormStartEventPropertiesParams &
    LeadResponseProperties & {
        inquirySelection: ILeadSubmitInquirySelection;
        ctaText?: string;
        isPriceNegotiation?: boolean;
    };

export const getAmplitudeLeadFormGenerateLeadEventProperties = (params: IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams) => {
    const {leadResponse, marketingApproval, inquirySelection, trackingContext, leadData, source, sourceSection, eventAction, ctaText, isPriceNegotiation} =
        params;

    const base = getAmplitudeLeadFormStartEventProperties({
        trackingContext,
        leadData,
        source,
        sourceSection,
        eventAction
    });

    const inquiryTopics = source === ApplicationSource.NegotiatePrice || isPriceNegotiation ? [] : getAmplitudeLeadFormInquiryTopics(source);
    const inquiryTopicsSelected = getAmplitudeLeadFormInquiryTopicsSelectedFromSubmit(source, inquirySelection);

    const resolvedMarketingApproval = marketingApproval ?? Boolean(leadResponse?.marketing_email || leadResponse?.marketing_sms);

    return {
        ...base,
        ...(ctaText ? {cta_text: ctaText} : {}),
        ...(leadResponse ? {transaction_id: leadResponse.uuid} : {}),
        inquiry_topics: inquiryTopics,
        inquiry_topics_selected: inquiryTopicsSelected,
        marketing_approval: resolvedMarketingApproval
    };
};
